import storage from "local-storage-fallback";

const store = () => {
  return storage;
};

const writeExpire = (key, value, expiry) => {
  const item = {
    value: JSON.stringify(value),
    expiry
  };
  store().setItem(key, JSON.stringify(item));
};

const readExpire = (key: string) => {
  const itemStr = store().getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    store().removeItem(key);
    return null;
  }
  return JSON.parse(item.value);
};

export { writeExpire, readExpire, store };
